import { logger } from '../common/utils/logger';

export const onEmailCopy: (email: string) => void = (email: string): void => {
	// try catch is for the clipboard function
	try {
		void navigator.clipboard.writeText(email);
	} catch (error) {
		logger.error({
			feature: 'knowledge-cards',
			element: 'profile-header',
			operation: 'email-copy',
			category: 'unknown',
			error,
			functionName: 'onEmailCopy',
		});
	}
};
